import {EnvironmentProfile} from '@medad-sep/core';

export const ENV_CONFIG = (window as Window & {configOverride?: Record<string, unknown>})?.configOverride;

export const DEFAULT_CONFIG = {
  baseApiUrl: 'https://api-sep.medadstg.com',
  defaultAppLang: 'en',
  tenant: 'medad',
  environmentProfile: EnvironmentProfile.PRODUCTION,
  ssoConfigs: {
    url: 'https://sso.medadstg.com/realms/medad',
    clientId: 'sep-client',
  },
} as const;

export const DEFAULT_FEATBIT_CONFIG = {
  featBitConfig: {
    sdkKey: '8EtV3kTKi0SrUxoHHupGWAzw0l-3ce6kGJGgyt3tp-_A',
    streamingUri: 'wss://featbit-evaluation.qa.medad.com',
    eventsUrl: 'https://featbit-evaluation.qa.medad.com',
    pollingUri: 'https://featbit-evaluation.qa.medad.com',
  },
  user: {
    keyId: 'tester-id',
  },
} as const;
